
import { AIStaffRole } from "@/lib/types";

export const staffRoles = [
  {
    role: "marketing" as AIStaffRole,
    title: "Marketing Assistant",
    icon: "🚀",
    description: "Creates and optimizes marketing content across multiple channels",
    primaryColor: "#4f46e5",
    status: "available" as const,
    skills: ["Content Creation", "Social Media", "Email Marketing", "SEO", "Analytics"]
  },
  {
    role: "sales" as AIStaffRole,
    title: "Sales Assistant",
    icon: "💼",
    description: "Helps you manage leads and increase conversion rates",
    primaryColor: "#0ea5e9",
    status: "coming_soon" as const,
    skills: ["Lead Generation", "CRM", "Pipeline Management", "Follow-ups"]
  },
  {
    role: "customer-support" as AIStaffRole,
    title: "Customer Support Assistant",
    icon: "🎧",
    description: "Handles customer inquiries and provides timely support",
    primaryColor: "#10b981",
    status: "coming_soon" as const,
    skills: ["Ticket Management", "Response Templates", "Customer Satisfaction"]
  },
  {
    role: "data-entry" as AIStaffRole,
    title: "Data Entry Assistant",
    icon: "📊",
    description: "Processes and organizes data for your business",
    primaryColor: "#f59e0b",
    status: "coming_soon" as const,
    skills: ["Data Processing", "Organization", "Information Extraction"]
  }
];

export const marketingTools = [
  {
    id: "social-media",
    title: "Social Media Management",
    description: "Create, schedule, and analyze posts across platforms",
    icon: "📱",
    isActive: true,
  },
  {
    id: "email-campaigns",
    title: "Email Campaigns",
    description: "Design and send automated email sequences",
    icon: "📧",
    isActive: true,
  },
  {
    id: "content-creation",
    title: "Content Creation",
    description: "Generate blog posts, articles, and website copy",
    icon: "✍️",
    isActive: true,
  },
  {
    id: "seo-tools",
    title: "SEO Tools",
    description: "Optimize your content for search engines",
    icon: "🔍",
    isActive: true,
  },
];

export const subscriptionPlans = [
  {
    id: "basic",
    title: "Basic Plan",
    description: "Essential tools for small businesses",
    price: 29,
    features: [
      "1 AI Staff Member",
      "Basic Automation",
      "Limited Integrations",
      "Standard Support",
    ],
    isPopular: false,
  },
  {
    id: "growth",
    title: "Growth Plan",
    description: "Advanced features for growing businesses",
    price: 79,
    features: [
      "3 AI Staff Members",
      "Advanced Automation",
      "Multiple Integrations",
      "Priority Support",
      "Analytics Dashboard",
    ],
    isPopular: true,
  },
  {
    id: "enterprise",
    title: "Enterprise Plan",
    description: "Custom solutions for large organizations",
    price: 199,
    features: [
      "Unlimited AI Staff",
      "Custom Automation Workflows",
      "All Integrations",
      "Dedicated Support",
      "Advanced Analytics",
      "API Access",
    ],
    isPopular: false,
  },
];
